import { useRouter } from 'expo-router'

import { GTM } from '@/src/general/utils/gtm'
import { EVENTS, type PUBLICATION_TRACKING_SOURCE, type TRACKING_SOURCE } from '@/src/general/utils/gtm/constants'
import type { TGTMVariables } from '@/src/general/utils/gtm/types/GTMVariables'
import { useRoutes } from '@/src/general/utils/routes'
import { stopPropagation } from '@/src/general/utils/stopPropagation'

import { useSharePublication } from '../../hooks/useSharePublication'
import type { TPublicationToShare } from '../PublicationShareModal'

export type TUsePublicationHandlersProps = {
  publication: TPublicationToShare
  trackingSource: TRACKING_SOURCE
  publicationTrackingSource?: PUBLICATION_TRACKING_SOURCE
  cardClickEvent?: EVENTS
  trackingVariables?: TGTMVariables
}

export const usePublicationHandlers = ({
  publication,
  trackingSource,
  trackingVariables,
  publicationTrackingSource,
  cardClickEvent = EVENTS.PUBLICATION_CARD_CLICK,
}: TUsePublicationHandlersProps) => {
  const { routes } = useRoutes()
  const router = useRouter()
  const { share } = useSharePublication()

  return {
    onSharePress: stopPropagation(() => share(publication, trackingSource)),
    onCardPress: () => {
      GTM.sendEvent(cardClickEvent, { trackingSource, ...trackingVariables })
      router.push(routes.publicationById({ id: publication.id, publicationTrackingSource, source: trackingSource }))
    },
    onCommentPress: stopPropagation(() =>
      router.push(
        routes.publicationById({
          id: publication.id,
          publicationTrackingSource,
          source: trackingSource,
          section: 'comments',
        }),
      ),
    ),
  }
}
